(() => {
  const STORAGE_KEY = 'bb_show_second_image';

  function setButtonState(isOn) {
    document.querySelectorAll('[data-bb-pattern-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');

      const sw = btn.querySelector(
        '[data-bb-pattern-toggle-switch], .bb-pattern-toggle-only__switch, .bb-pattern-toggle__switch'
      );
      const knob = btn.querySelector(
        '.bb-pattern-toggle-only__knob, .bb-pattern-toggle__knob'
      );
      const label = btn.querySelector(
        '.bb-pattern-toggle-only__label, .bb-pattern-toggle__label'
      );

      if (sw) {
        sw.style.background = isOn ? '#7C661D' : '#d9dbe1';
      }
      if (knob) {
        knob.style.transform = isOn ? 'translateX(22px)' : 'translateX(0)';
      }
  if (label) {
  label.style.paddingLeft = '11px';      // left padding
  label.style.fontFamily = '"IBM Plex Sans", sans-serif';
  label.style.fontWeight = '500';        // Regular
  label.style.fontSize = '12px';
  label.style.lineHeight = '11px';
  label.style.letterSpacing = '.5px';
  label.style.color = '#101012';
  label.style.textTransform = 'none';
  btn.style.display = 'inline-flex';
btn.style.alignItems = 'center';
btn.style.gap = '12px';

}

    });

    document.documentElement.classList.toggle('bb-show-second-image', isOn);
  }

  function swapGridImages(isOn) {
    document.querySelectorAll('[data-grid-images]').forEach((wrap) => {
      const first = wrap.getAttribute('data-bb-first-image');
      const second = wrap.getAttribute('data-bb-second-image');
      const target = isOn && second ? second : first;

      if (!target) return;

      const activeImg = wrap.querySelector(
        '.product-grid-item__image-wrapper.is-active img, .product-grid-item__image-wrapper.is-active source'
      );

      if (!activeImg) return;

      const tag = activeImg.tagName.toLowerCase();

      if (tag === 'img') {
        activeImg.src = target;
        activeImg.srcset = target;
      }

      if (tag === 'source') {
        activeImg.srcset = target;
      }

      const activeSource = wrap.querySelector('.product-grid-item__image-wrapper.is-active source');
      if (activeSource) {
        activeSource.srcset = target;
      }
    });
  }

  function applyState(isOn) {
    setButtonState(isOn);
    swapGridImages(isOn);
  }

  function init() {
    const buttons = document.querySelectorAll('[data-bb-pattern-toggle]');
    if (!buttons.length) return;

    const saved = localStorage.getItem(STORAGE_KEY) === 'true';
    applyState(saved);

    buttons.forEach((btn) => {
      if (btn.dataset.bbBound === 'true') return;
      btn.dataset.bbBound = 'true';

      btn.addEventListener('click', () => {
        const next = btn.getAttribute('aria-pressed') !== 'true';
        localStorage.setItem(STORAGE_KEY, String(next));
        applyState(next);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
